import React from "react";
import "../../../src/App.css";
import "./Service.css";
import Consultant from "../../images/s-1.jpg";
import Analytics from "../../images/s-2.jpg";
import Financial from "../../images/s-3.jpg";
import Button from "../../Components/Button/Button"
import Herobg from "../../images/service-bg.jpg"

const Service = () => {
  return (
    <>
    {/* <img className="hero" src={Herobg} alt="" /> */}
      <div>
        <div className="service-heading-wrapper">
          <h1 style={{fontWeight: 600}}>Our Service</h1>
        </div>
        <div className="grid-service">
          <div className="grid-1">
            <div className="grid-img">
              <img src={Consultant} alt="" />
            </div>
            <div className="grid-text">
              <div className="grid-text-heading">Business Consultant</div>
              <p className="grid-text-para">
                have suffered alteration in some form, by injected humour, or
                randomised words which don't look evenslightly believable. If
                you are
              </p>
            </div>
          </div>
          <div className="grid-2">
            <div className="grid-img">
              <img src={Analytics} alt="" />
            </div>
            <div className="grid-text">
              <div className="grid-text-heading">Marketing Analytics</div>
              <p className="grid-text-para">
                have suffered alteration in some form, by injected humour, or
                randomised words which don't look evenslightly believable. If
                you are
              </p>
            </div>
          </div>
          <div className="grid-3">
            <div className="grid-img">
              <img src={Financial} alt="" />
            </div>
            <div className="grid-text">
              <div className="grid-text-heading">Financial Planning</div>
              <p className="grid-text-para">
                have suffered alteration in some form, by injected humour, or
                randomised words which don't look evenslightly believable. If
                you are
              </p>
            </div>
          </div>
        </div>
        <Button/>
      </div>
    </>
  );
};

export default Service;
